export enum EOfferDraftStatus {
  initial = 'initial',
  pending = 'pending',
  success = 'success',
  fail = 'fail',
}

export interface IDraftState {
  status: EOfferDraftStatus;
}
